function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useRef } from 'react';
import { Trans } from 'react-i18next';
import { Button as CustomButton } from '../button';
const acceptedTypes = {
  '*': '*',
  image: 'image/*',
  csv: '.csv',
  gpx: '.gpx',
  geojson: '.geojson',
  shp: '.zip',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  sheet: '.xlsx,.xls,.csv'
};
export function FileInputButton({
  Button: _Button,
  buttonLabel,
  type,
  file,
  multiple,
  onChange,
  onChangeFiles,
  ...props
}) {
  const inputRef = useRef(null);
  function handleChange({
    target: {
      files
    }
  }) {
    if (multiple && onChangeFiles) {
      if (files && files.length > 0) onChangeFiles(Array.from(files));
      return;
    }
    const newFile = files?.[0];
    onChange(newFile || file);
  }
  const Button = _Button || CustomButton;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
    accept: acceptedTypes[type],
    multiple: multiple,
    onChange: handleChange,
    onClick: ({
      currentTarget
    }) => currentTarget.value = '',
    ref: inputRef,
    style: {
      display: 'none'
    },
    type: "file"
  }), /*#__PURE__*/React.createElement(Button, _extends({
    onClick: () => inputRef.current?.click()
  }, props), buttonLabel || /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.actions.choose",
    values: {
      context: type === '*' ? 'file' : type
    }
  })));
}